<template>
  <div class="swiper-container" :class="isPhone ? '' : 'pc-container'">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide">
        <img v-if="!isPhone" src="@/assets/img/banner.png" alt="banner" />
        <img v-else src="@/assets/img/banner_phone1.png" alt="banner1" />
      </div>
      <div class="swiper-slide">
        <img v-if="!isPhone" src="@/assets/img/banner22.png" alt="banner2" />
        <img v-else src="@/assets/img/banner_phone22.png" alt="banner2" />
      </div>
      <div class="swiper-slide">
        <img v-if="!isPhone" src="@/assets/img/banner33.png" alt="banner2" />
        <img v-else src="@/assets/img/banner_phone33.png" alt="banner2" />
      </div> -->
      <!-- <div class="swiper-slide">
        <img v-if="!isPhone" :src="this.pcBannerImage" alt="banner3" />
        <img v-else :src="this.mobileBannerImage" alt="banner3" />
      </div> -->

      <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
        <img v-if="!isPhone" :src="item.pcBannerImage" alt="banner2" />
        <img v-else :src="item.mobileBannerImage" alt="banner2" />
      </div>


    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getActivityLatest,getBannerList } from "@/api/home";

export default {
  props: ["isPhone"], // 定义接收父组件传来的 props
  data() {
    return {
      configUrl: process.env.VUE_APP_SERVER_URL,
      pcBannerImage: "",
      mobileBannerImage: "",
      linkUrl: "",
      bannerList:[]
    };
  },
  async mounted() {
    await this.getBanner()
    this.getActivityData();
    this.swiper = new Swiper(".swiper-container", {
      slidesPerView: 1,
      // spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        //自动开始
        delay: 2000, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      on: {
        click: (event) => {
          console.log(event);
          // 通过 this.swiper 获取实例
          // const realIndex = this.swiper.realIndex;
          // if (realIndex === 0) {
          //   this.scrollTo();
          // } else if (realIndex === 1) {
          //   this.goLink("register");
          // } else if (realIndex === 2) {
          //   this.goLink("activity");
          // }
        },
      },
    });
  },
  methods: {
    async getBanner(){
      const res = await getBannerList();
      console.log('========>banner: ',res);
      if(res.code == 200){
        this.bannerList = res.data; // 假设组件中有 bannerList 状态
      }
     

    },
    // 获取活动数据
    async getActivityData() {
      const res = await getActivityLatest();
      console.log("getActivityData");
      console.log(res);
      this.pcBannerImage = res.data.pcBannerImage;
      this.mobileBannerImage = res.data.mobileBannerImage;
      this.linkUrl = res.data.linkUrl;
    },
    scrollTo() {
      console.log("scrollTo");
      const element = document.getElementById("platform");
      console.log(element);
      if (element) {
        const offsetPosition = element.offsetTop - (this.isPhone ? 0 : 80);
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    goLink(val) {
      if (val == "register") {
        window.open(`${this.configUrl}/register`);
      } else if (val == "activity") {
        window.open(this.linkUrl);
      }
    },
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  /* height: 300px; */
  z-index: 0;
}
.pc-container {
  aspect-ratio: 1920 / 594;
}

.swiper-container .swiper-slide img {
  width: 100%;
}
.pc-container .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
